import React from 'react'

import { F0Button, useAiChat } from '@factorialco/f0-react'
import { One } from '@factorialco/f0-react/icons/ai'

interface AskOneButtonProps {
  label: string
  prompt: string | null | undefined
  /**
   * Forwarded to `F0Button`. Kept as `string` to match the existing
   * loose typing used by `CommsButton`/`SidebarCard` callers.
   */
  size?: string
  onClick?: () => void
}

/**
 * Button that opens the One AI chat and sends a predefined prompt.
 * Always renders with the AI ("One") icon and the AI button variant,
 * regardless of the label coming from CMS.
 */
const AskOneButton = ({ label, prompt, size = 'md', onClick }: AskOneButtonProps) => {
  const { sendMessage, setOpen: setAiChatOpen } = useAiChat()

  const handleClick = () => {
    setAiChatOpen(true)
    if (prompt) {
      sendMessage(prompt)
    }
    onClick?.()
  }

  // `F0Button`'s public `ButtonVariant` type omits "ai", but the underlying
  // component (and wrapped F0Button forwardRef) accepts it at runtime — same
  // variant used by the internal AIButton.
  return <F0Button label={label} icon={One} onClick={handleClick} size={size} variant="ai" />
}

export default AskOneButton
